"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2890],{

/***/ 8117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sg": function() { return /* reexport */ column_Column; },
  "W2": function() { return /* reexport */ container_Container; },
  "X2": function() { return /* reexport */ row_Row; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/gridview/container/Container.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Container = function(_param) {
    var children = _param.children, className = _param.className, _size = _param.size, size = _size === void 0 ? 'wide' : _size, rest = _objectWithoutProperties(_param, [
        "children",
        "className",
        "size"
    ]);
    var classNames = (0,functions.classnames)('container', "container-".concat(size), className);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: classNames
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var container_Container = (Container);

;// CONCATENATED MODULE: ./components/base/gridview/container/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/row/Row.tsx


function Row_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Row_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Row_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Row_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Row_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Row_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Row = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, content = _param.content, direction = _param.direction, gutter = _param.gutter, justify = _param.justify, wrap = _param.wrap, children = _param.children, testId = _param.testId, rest = Row_objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "content",
        "direction",
        "gutter",
        "justify",
        "wrap",
        "children",
        "testId"
    ]);
    var classNames = {
        'row-align': align,
        'row-content': content,
        'row-direction': direction,
        'row-gutter': gutter,
        'row-justify': justify,
        'row-wrap': wrap
    };
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value) {
                classNames["row-".concat(breakpoint, "-").concat(prop)] = value;
            }
        }
    };
    createClassName('xs', xs);
    createClassName('sm', sm);
    createClassName('md', md);
    createClassName('lg', lg);
    createClassName('xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", Row_objectSpread({
        className: (0,functions.classnames)('row', classNames, className),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var row_Row = (Row);

;// CONCATENATED MODULE: ./components/base/gridview/row/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/column/Column.tsx


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function Column_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Column_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Column_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Column_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Column_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Column_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Column = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, offset = _param.offset, order = _param.order, size = _param.size, children = _param.children, testId = _param.testId, rest = Column_objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "offset",
        "order",
        "size",
        "children",
        "testId"
    ]);
    var classNames = [
        'col'
    ];
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value !== undefined) {
                if (prop === 'size') {
                    classNames.push("col".concat(breakpoint, "-").concat(value));
                } else {
                    classNames.push("col".concat(breakpoint, "-").concat(prop, "-").concat(value));
                }
            }
        }
    };
    createClassName('', {
        size: size,
        offset: offset,
        align: align,
        order: order
    });
    createClassName('-xs', xs);
    createClassName('-sm', sm);
    createClassName('-md', md);
    createClassName('-lg', lg);
    createClassName('-xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", Column_objectSpread({
        className: functions.classnames.apply(void 0, _toConsumableArray(classNames).concat([
            className
        ])),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var column_Column = (Column);

;// CONCATENATED MODULE: ./components/base/gridview/column/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/index.tsx





/***/ }),

/***/ 6653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var begonya_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44);
/* harmony import */ var begonya_functions__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(begonya_functions__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Icon = function(_param) {
    var className = _param.className, fill = _param.fill, label = _param.label, name = _param.name, _size = _param.size, size = _size === void 0 ? 'medium' : _size, rest = _objectWithoutProperties(_param, [
        "className",
        "fill",
        "label",
        "name",
        "size"
    ]);
    var classNames = (0,begonya_functions__WEBPACK_IMPORTED_MODULE_1__.classnames)('c-icon', "c-icon--size-".concat(size), name, className);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", _objectSpread({
        className: classNames,
        role: "img",
        "aria-label": label || name,
        style: {
            color: fill,
            fontSize: typeof size === 'number' ? size : undefined
        }
    }, rest)));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 2676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Icon__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6653);



/***/ }),

/***/ 9617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iz": function() { return /* reexport */ AppContextProvider; },
  "qD": function() { return /* reexport */ useApp; }
});

// UNUSED EXPORTS: AppContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./core/contexts/app/context.tsx

var AppContext = /*#__PURE__*/ (0,react.createContext)(null);
var AppContextProvider = AppContext.Provider;
var useApp = function() {
    var app = (0,react.useContext)(AppContext);
    if (app) {
        return app;
    }
    throw new Error('useApp must be used within a AppContextProvider.');
};

;// CONCATENATED MODULE: ./core/contexts/app/index.tsx



/***/ }),

/***/ 58:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ path_namespaceObject; }
});

// UNUSED EXPORTS: color

// NAMESPACE OBJECT: ./core/utils/path.ts
var path_namespaceObject = {};
__webpack_require__.r(path_namespaceObject);
__webpack_require__.d(path_namespaceObject, {
  "app": function() { return app; },
  "asset": function() { return asset; },
  "url": function() { return url; }
});

;// CONCATENATED MODULE: ./constants/enums.ts
var NodeEnv;
(function(NodeEnv) {
    NodeEnv["Development"] = "development";
    NodeEnv["Production"] = "production";
    NodeEnv["Test"] = "test";
})(NodeEnv || (NodeEnv = {}));

;// CONCATENATED MODULE: ./core/utils/path.ts

/**
 * The ``app`` function returns the fully qualified path to the app directory.
 * You may also use the ``app`` function to generate a fully qualified path
 * to a given file relative to the application directory.
 *
 * @param {string} pathname Added directory path
 * @returns {string}
 */ var app = function(context, pathname) {
    var origin = context.url || '/';
    if (!pathname) return origin;
    if (pathname.indexOf('http') === 0) {
        return pathname;
    }
    if (context.environment === NodeEnv.Production) {
        return "/".concat(pathname);
    }
    return "/".concat(context.key, "/").concat(pathname);
};
var url = function(context, pathname) {
    var origin = context.url || '/';
    if (context.environment === NodeEnv.Production) {
        return "".concat(origin, "/").concat(pathname);
    }
    return "".concat(origin, "/").concat(context.key, "/").concat(pathname);
};
var asset = function(context, path) {
    if (!path) return '';
    if (path.indexOf('http') !== -1) {
        return path;
    } else {
        return "".concat(context.cdn, "/").concat(path);
    }
};

;// CONCATENATED MODULE: ./core/utils/index.ts






/***/ }),

/***/ 2890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pathname_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/index.tsx


var Button = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 5664));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5664)
            ];
        }
    }
});
var Heading = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 1884));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1884)
            ];
        }
    }
});
var Html = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9791).then(__webpack_require__.bind(__webpack_require__, 9791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9791)
            ];
        }
    }
});
var Section = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(2263)]).then(__webpack_require__.bind(__webpack_require__, 2263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2263)
            ];
        }
    }
});
var Image = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 5244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5244)
            ];
        }
    }
});
var Video = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 4254).then(__webpack_require__.bind(__webpack_require__, 4254));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4254)
            ];
        }
    }
});
var Iframe = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var Accordion = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 814).then(__webpack_require__.bind(__webpack_require__, 814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(814)
            ];
        }
    }
});
var ArticleCard = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(94)]).then(__webpack_require__.bind(__webpack_require__, 94));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94)
            ];
        }
    }
});
var CardList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(874)]).then(__webpack_require__.bind(__webpack_require__, 874));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(874)
            ];
        }
    }
});
var Header = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(7390), __webpack_require__.e(9619)]).then(__webpack_require__.bind(__webpack_require__, 9619));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9619)
            ];
        }
    }
});
var Footer = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(8110)]).then(__webpack_require__.bind(__webpack_require__, 8110));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8110)
            ];
        }
    }
});
var Tabs = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 6303).then(__webpack_require__.bind(__webpack_require__, 6303));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6303)
            ];
        }
    }
});
var Test = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3111).then(__webpack_require__.bind(__webpack_require__, 3111));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3111)
            ];
        }
    }
});
var MainSlideShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(5262)]).then(__webpack_require__.bind(__webpack_require__, 5262));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5262)
            ];
        }
    }
});
var GallerySlideShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(5198)]).then(__webpack_require__.bind(__webpack_require__, 5198));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5198)
            ];
        }
    }
});
var PageHeader = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 5725).then(__webpack_require__.bind(__webpack_require__, 5725));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5725)
            ];
        }
    }
});
var Blog = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(1869)]).then(__webpack_require__.bind(__webpack_require__, 1869));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1869)
            ];
        }
    }
});
var BlogList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(1321)]).then(__webpack_require__.bind(__webpack_require__, 1321));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1321)
            ];
        }
    }
});
var VideoList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(4983), __webpack_require__.e(5270)]).then(__webpack_require__.bind(__webpack_require__, 5270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5270)
            ];
        }
    }
});
var LazyImage = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(6901)]).then(__webpack_require__.bind(__webpack_require__, 6901));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6901)
            ];
        }
    }
});
var GoTurkiyeVideo = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(4983)]).then(__webpack_require__.bind(__webpack_require__, 4983));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4983)
            ];
        }
    }
});
var GoTurkiyeImage = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 4154));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4154)
            ];
        }
    }
});
var ImageList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(3579)]).then(__webpack_require__.bind(__webpack_require__, 3579));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3579)
            ];
        }
    }
});
var ImageSlidesShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(9971)]).then(__webpack_require__.bind(__webpack_require__, 9971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9971)
            ];
        }
    }
});
var SlidesShow = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 7465));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7465)
            ];
        }
    }
});
var SustainabilitySlideshow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(3516)]).then(__webpack_require__.bind(__webpack_require__, 3516));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3516)
            ];
        }
    }
});
var SocialMediaShare = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(937)
            ];
        }
    }
});
var Hero = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(9211)]).then(__webpack_require__.bind(__webpack_require__, 9211));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9211)
            ];
        }
    }
});
var VideoSlidesShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(4983), __webpack_require__.e(3910)]).then(__webpack_require__.bind(__webpack_require__, 3910));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3910)
            ];
        }
    }
});
var HotelSlidesShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(474)]).then(__webpack_require__.bind(__webpack_require__, 474));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(474)
            ];
        }
    }
});
var SectionSlidesShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(2557)]).then(__webpack_require__.bind(__webpack_require__, 2557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2557)
            ];
        }
    }
});
var AnimatedHero = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(2725)]).then(__webpack_require__.bind(__webpack_require__, 2725));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2725)
            ];
        }
    }
});
var FacilityList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(5936)]).then(__webpack_require__.bind(__webpack_require__, 5936));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5936)
            ];
        }
    }
});
var AsgInfoBar = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(4985)]).then(__webpack_require__.bind(__webpack_require__, 4985));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4985)
            ];
        }
    }
});
var AsgInfoBarList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(8613)]).then(__webpack_require__.bind(__webpack_require__, 8613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8613)
            ];
        }
    }
});
var AsgBrandCardList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(8719)]).then(__webpack_require__.bind(__webpack_require__, 8719));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8719)
            ];
        }
    }
});
var AsgTeamList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(6813)]).then(__webpack_require__.bind(__webpack_require__, 6813));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6813)
            ];
        }
    }
});
var AsgPageBackDrop = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(2922)]).then(__webpack_require__.bind(__webpack_require__, 2922));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2922)
            ];
        }
    }
});
var AsgCarrier = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(4299)]).then(__webpack_require__.bind(__webpack_require__, 4299));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4299)
            ];
        }
    }
});
var AsgHeader = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(7390), __webpack_require__.e(4736)]).then(__webpack_require__.bind(__webpack_require__, 4736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4736)
            ];
        }
    }
});
var AsgFooter = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(7390), __webpack_require__.e(4646)]).then(__webpack_require__.bind(__webpack_require__, 4646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4646)
            ];
        }
    }
});
var AsgMainSlideShow = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(6993)]).then(__webpack_require__.bind(__webpack_require__, 6993));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6993)
            ];
        }
    }
});
var AsgLogoArchive = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(546)]).then(__webpack_require__.bind(__webpack_require__, 546));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546)
            ];
        }
    }
});
var AsgRewards = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(5231)]).then(__webpack_require__.bind(__webpack_require__, 5231));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5231)
            ];
        }
    }
});
var AsgOrganizationChart = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(6792)]).then(__webpack_require__.bind(__webpack_require__, 6792));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6792)
            ];
        }
    }
});
var AsgCookieButton = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9351), __webpack_require__.e(864)]).then(__webpack_require__.bind(__webpack_require__, 864));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(864)
            ];
        }
    }
});
function getter(name) {
    switch(name){
        case 'card':
            return ArticleCard;
        case 'card-list':
            return CardList;
        case 'container':
            return gridview/* Container */.W2;
        case 'heading':
            return Heading;
        case 'html':
            return Html;
        case 'header':
            return Header;
        case 'footer':
            return Footer;
        case 'row':
            return gridview/* Row */.X2;
        case 'column':
            return gridview/* Column */.sg;
        case 'button':
            return Button;
        case 'accordion':
            return Accordion;
        case 'tabs':
            return Tabs;
        case 'test-component':
            return Test;
        case 'main-slide-show':
            return MainSlideShow;
        case 'galeri-slider':
            return GallerySlideShow;
        case 'page-header':
            return PageHeader;
        case 'blog':
            return Blog;
        case 'blog-list':
            return BlogList;
        case 'video-list':
            return VideoList;
        case 'lazy-image':
            return LazyImage;
        case 'go-turkiye-video':
            return GoTurkiyeVideo;
        case 'go-turkiye-image':
            return GoTurkiyeImage;
        case 'image':
            return Image;
        case 'image-list':
            return ImageList;
        case 'image-slides-show':
            return ImageSlidesShow;
        case 'slides-show':
            return SlidesShow;
        case 'sustainability-slides-show':
            return SustainabilitySlideshow;
        case 'social-media-share':
            return SocialMediaShare;
        case 'hero':
            return Hero;
        case 'video-slides-show':
            return VideoSlidesShow;
        case 'hotel-slides-show':
            return HotelSlidesShow;
        case 'section':
            return Section;
        case 'section-slides-show':
            return SectionSlidesShow;
        case 'animated-hero':
            return AnimatedHero;
        case 'facility-list':
            return FacilityList;
        case 'video':
            return Video;
        case 'asg-info-bar':
            return AsgInfoBar;
        case 'asg-info-bar-list':
            return AsgInfoBarList;
        case 'asg-brand-card-list':
            return AsgBrandCardList;
        case 'asg-team-list':
            return AsgTeamList;
        case 'asg-page-back-drop':
            return AsgPageBackDrop;
        case 'asg-carrier':
            return AsgCarrier;
        case 'asg-header':
            return AsgHeader;
        case 'asg-footer':
            return AsgFooter;
        case 'asg-main-slide-show':
            return AsgMainSlideShow;
        case 'asg-logo-archive':
            return AsgLogoArchive;
        case 'asg-rewards':
            return AsgRewards;
        case 'iframe':
            return Iframe;
        case 'asg-organization-chart':
            return AsgOrganizationChart;
        case 'asg-cookie-button':
            return AsgCookieButton;
    }
};

;// CONCATENATED MODULE: ./core/render.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var render = function(component1, context) {
    var id = component1.id, name = component1.name, props = component1.props, refs = component1.refs, children = component1.children;
    if (name === 'view') {
        var view = context.page.views[id];
        if (view) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: view.map(function(component) {
                    return render(component, context);
                })
            }, id));
        }
    } else {
        var Component = getter(name);
        if (Component) {
            if (children.length) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs, {
                    children: children.map(function(child) {
                        return render(child, context);
                    })
                }), id));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs), id));
            }
        }
        if (false) {}
    }
};
/* harmony default export */ var core_render = (render);

;// CONCATENATED MODULE: ./components/error/Error.tsx

var Error = function(param) {
    var code = param.code, type = param.type, message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "error",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "error-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: code
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/wap-platform.svg",
                alt: "WAP Platform"
            })
        ]
    }));
};
/* harmony default export */ var error_Error = (Error);

;// CONCATENATED MODULE: ./components/error/index.tsx


// EXTERNAL MODULE: ./components/base/icon/index.tsx
var icon = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/widgets/cookie-manager/enums.ts
var CookieName;
(function(CookieName) {
    CookieName["Advertising"] = 'GT_Advertising';
    CookieName["AllowedSettings"] = 'GT_AllowedSettings';
    CookieName["Performance"] = 'GT_Performance';
    CookieName["Required"] = 'GT_Required';
})(CookieName || (CookieName = {}));

;// CONCATENATED MODULE: ./components/widgets/cookie-manager/constants.ts

var COOKIE_NAMES = {
    performance: CookieName.Performance,
    advertising: CookieName.Advertising
};

;// CONCATENATED MODULE: ./components/widgets/cookie-manager/CookieManager.tsx







function CookieManager_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CookieManager_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CookieManager_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CookieManager = function(props1) {
    var ref = (0,react.useState)(props1.visibility || false), modalVisibility = ref[0], setModalVisibility = ref[1];
    var ref1 = (0,react.useState)('required'), activeAccordion = ref1[0], setActiveAccordion = ref1[1];
    var ref2 = (0,react.useState)({
        performance: false,
        advertising: false,
        required: true
    }), cookieObject = ref2[0], setCookieObject = ref2[1];
    var ref3 = (0,react.useState)(false), barVisibility = ref3[0], setBarVisibility = ref3[1];
    var app = (0,contexts_app/* useApp */.qD)();
    var cookie = new es6/* default */.Z();
    (0,react.useEffect)(function() {
        var settings = cookie.get(CookieName.AllowedSettings);
        if (settings) {
            setCookieObject(settings);
            handleDismiss();
        } else {
            setBarVisibility(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (props1.visibility) {
            setModalVisibility(props1.visibility);
        }
    }, [
        props1.visibility
    ]);
    var getTabs = function() {
        var tabs = [
            {
                label: app.settings.translations['cookieRequiredTitle'],
                value: 'required',
                text: app.settings.translations['cookieRequiredText'],
                disabled: true
            },
            {
                label: app.settings.translations['cookiePerformanceTitle'],
                value: 'performance',
                text: app.settings.translations['cookiePerformanceText']
            },
            {
                label: app.settings.translations['cookieAdvertisingTitle'],
                value: 'advertising',
                text: app.settings.translations['cookieAdvertisingText']
            }, 
        ];
        return tabs;
    };
    var handleDismiss = function() {
        setModalVisibility(false);
        if (props1.onDismiss) {
            props1.onDismiss();
        }
    };
    var handleAddCookie = function(name, value, settings) {
        cookie.set(name, value, settings);
    };
    var handleRemoveCookie = function(name) {
        cookie.remove(name);
    };
    var handleUpdateCookies = function(isAcceptAll) {
        Object.keys(cookieObject).forEach(function(key) {
            var name = COOKIE_NAMES[key];
            if (name) {
                if (isAcceptAll) {
                    handleAddCookie(name, true);
                } else {
                    if (cookieObject[key] === true) {
                        handleAddCookie(name, true);
                    } else {
                        handleRemoveCookie(name);
                    }
                }
            }
        });
    };
    var handleSaveSettings = function(isAcceptAll) {
        var settings = isAcceptAll ? {
            performance: true,
            advertising: true,
            required: true
        } : cookieObject;
        if (settings) {
            if (isAcceptAll) {
                setCookieObject(settings);
            }
            handleAddCookie(CookieName.AllowedSettings, JSON.stringify(settings));
            handleUpdateCookies(isAcceptAll);
            setBarVisibility(false);
        }
        handleDismiss();
    };
    var TabItem = function(props) {
        if (activeAccordion !== props.name) return null;
        var isChecked = props.disabled ? true : cookieObject[props.name] ? true : false;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cookie-manager-tab-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-title",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "item-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "item-text",
                            children: props.text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "item-value",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "toggle-switch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        checked: isChecked,
                                        onChange: function(event) {
                                            if (!props.disabled) setCookieObject(CookieManager_objectSpread({}, cookieObject, CookieManager_defineProperty({}, props.name, event.target.checked)));
                                        },
                                        readOnly: props.disabled
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: [
                                            'toggle-slider',
                                            props.disabled && 'disabled'
                                        ].filter(function(x) {
                                            return x;
                                        }).join(' ')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "toggle-text",
                                        children: [
                                            isChecked ? app.settings.translations['active'] : app.settings.translations['deactive'],
                                            props.disabled && app.settings.translations['everytime']
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }));
    };
    var renderTabs = function() {
        var tabs = getTabs();
        return tabs.map(function(tab, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: [
                    'cookie-manager-tab-title',
                    activeAccordion === tab.value && 'is-active', 
                ].filter(function(x) {
                    return x;
                }).join(' '),
                onClick: function() {
                    return setActiveAccordion(tab.value);
                },
                onKeyDown: function(event) {
                    if (event.key === 'Enter') {
                        setActiveAccordion(tab.value);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: tab.label
            }, index);
        });
    };
    var renderTabContent = function() {
        var tabs = getTabs();
        return tabs.map(function(tab, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TabItem, {
                title: tab.label,
                text: tab.text,
                disabled: tab.disabled,
                name: tab.value
            }, index);
        });
    };
    var renderModal = function() {
        if (!modalVisibility) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cookie-manager-modal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cookie-manager-modal-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cookie-manager-modal-panel",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title",
                                    children: app.settings.translations['cookieModalTitle']
                                }),
                                renderTabs()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cookie-manager-modal-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cookie-manager-tab-content",
                                    children: renderTabContent()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cookie-manager-modal-foot",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cookie-manager-tab-button stable",
                                            onClick: function() {
                                                return handleSaveSettings();
                                            },
                                            onKeyDown: function(event) {
                                                if (event.key === 'Enter') {
                                                    handleSaveSettings();
                                                }
                                            },
                                            role: "button",
                                            tabIndex: 0,
                                            children: app.settings.translations['cookieSave']
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cookie-manager-tab-button",
                                            onClick: function() {
                                                return handleSaveSettings(true);
                                            },
                                            onKeyDown: function(event) {
                                                if (event.key === 'Enter') {
                                                    handleSaveSettings(true);
                                                }
                                            },
                                            role: "button",
                                            tabIndex: 0,
                                            children: app.settings.translations['cookieAccept']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cookie-manager-modal-close",
                            onClick: function() {
                                return handleDismiss();
                            },
                            onKeyDown: function(event) {
                                if (event.key === 'Enter') {
                                    handleDismiss();
                                }
                            },
                            role: "button",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                name: "icon-close"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cookie-manager-modal-body",
                    onClick: function() {
                        return handleDismiss();
                    },
                    onKeyDown: function(event) {
                        if (event.key === 'Enter') {
                            handleDismiss();
                        }
                    },
                    role: "button",
                    tabIndex: 0
                })
            ]
        }));
    };
    var renderBar = function() {
        if (!barVisibility) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cookie-manager-bar",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: app.settings.translations['cookieText']
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cookie-manager-buttons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cookie-manager-button stable",
                            onClick: function() {
                                return setModalVisibility(true);
                            },
                            onKeyDown: function(event) {
                                if (event.key === 'Enter') {
                                    setModalVisibility(true);
                                }
                            },
                            role: "button",
                            tabIndex: 0,
                            children: app.settings.translations['cookieMore']
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cookie-manager-button",
                            onClick: function() {
                                return handleSaveSettings(true);
                            },
                            onKeyDown: function(event) {
                                if (event.key === 'Enter') {
                                    handleSaveSettings(true);
                                }
                            },
                            role: "button",
                            tabIndex: 0,
                            children: app.settings.translations['cookieAccept']
                        })
                    ]
                })
            ]
        }));
    };
    if (!barVisibility && !modalVisibility) return null;
    var classNames = [
        'cookie-manager',
        modalVisibility && 'is-open'
    ].filter(function(x) {
        return x;
    }).join(' ');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            renderBar(),
            renderModal()
        ]
    }));
};
/* harmony default export */ var cookie_manager_CookieManager = (CookieManager);

;// CONCATENATED MODULE: ./components/widgets/cookie-manager/index.ts


// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/base/seo-meta/SeoMeta.tsx




var SeoMeta = function(param) {
    var _context = param.context, page = _context.page, settings = _context.settings, environment = _context.environment;
    var suffix = "- ".concat(settings.shortName);
    var title = page.metatags.title || "".concat(page.title, " ").concat(suffix);
    var description = page.metatags.description || title;
    var url = utils/* path.url */.E.url(environment, page.path);
    var renderTitle = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("title", {
            children: title
        });
    };
    var renderMetaDescription = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "description",
            content: description
        }));
    };
    var renderMetaOg = function() {
        var ref, ref1;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:title",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:description",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:site_name",
                    content: settings.title || settings.shortName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref1 = page.image) === null || ref1 === void 0 ? void 0 : ref1.src))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:url",
                    content: url
                })
            ]
        }));
    };
    var renderMetaGoogle = function() {
        var ref, ref2;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "name",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref2 = page.image) === null || ref2 === void 0 ? void 0 : ref2.src))
                })
            ]
        }));
    };
    var renderMetaTwitter = function() {
        var ref, ref3, ref4;
        var twitter = page.metatags.twitter;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:title",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:site",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.site) || url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:description",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.summary) || (twitter === null || twitter === void 0 ? void 0 : twitter.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:image:src",
                    content: utils/* path.asset */.E.asset(environment, (twitter === null || twitter === void 0 ? void 0 : (ref = twitter.summaryImage) === null || ref === void 0 ? void 0 : ref.src) || (twitter === null || twitter === void 0 ? void 0 : (ref3 = twitter.image) === null || ref3 === void 0 ? void 0 : ref3.src) || ((ref4 = page.image) === null || ref4 === void 0 ? void 0 : ref4.src))
                })
            ]
        }));
    };
    var renderMetaOptions = function() {
        var content = [];
        if (page.metatags.isNoIndex) {
            content.push('noindex');
        }
        if (page.metatags.isNoFollow) {
            content.push('nofollow');
        }
        if (!content.length) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: content.join(',')
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            renderTitle(),
            renderMetaDescription(),
            renderMetaOg(),
            renderMetaGoogle(),
            renderMetaTwitter(),
            renderMetaOptions()
        ]
    }));
};
/* harmony default export */ var seo_meta_SeoMeta = (SeoMeta);

;// CONCATENATED MODULE: ./components/base/seo-meta/index.ts


// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
;// CONCATENATED MODULE: ./pages/[...pathname].tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _pathname_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _pathname_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _pathname_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Page = function(_param1) {
    var error = _param1.error, context = _objectWithoutProperties(_param1, [
        "error"
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        if (context.language) {
            var cookie = new es6/* default */.Z();
            cookie.set('language', context.language);
        }
    }, [
        context
    ]);
    var renderColorPalette = function() {
        var _theme = context.theme, colors = _theme.colors, neutrals = _theme.neutrals;
        var getcss = function(name, tones) {
            var entries = Object.entries(tones);
            return entries.map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                if (name.length == 2) {
                    return "--".concat(name).concat(key, ": ").concat(value, ";\n                    --").concat(name).concat(key, "-RGB: ").concat(value.replace(/[rgb|\(\)]/gm, ''), ";");
                }
                return "--".concat(name).concat(key, ": ").concat(value, ";");
            }).join('');
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
            type: "text/css",
            children: ":root {".concat([
                getcss('DN', neutrals.dark),
                getcss('LN', neutrals.light),
                getcss('PC', colors.primary),
                getcss('R', colors.red),
                getcss('Y', colors.yellow),
                getcss('G', colors.green),
                getcss('B', colors.blue),
                getcss('P', colors.purple),
                getcss('T', colors.teal), 
            ].join(''), "}")
        }));
    };
    var renderStyle = function() {
        var styles = context.settings.styles;
        if (styles) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                type: "text/css",
                children: styles
            }));
        }
    };
    var renderAlternates = function() {
        var alternates = context.page.alternates;
        if (alternates) {
            return alternates.map(function(param, index) {
                var title = param.title, href = param.href, hreflang = param.hreflang;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    title: title,
                    hrefLang: hreflang,
                    href: href
                }, index);
            });
        }
    };
    var renderPlugins = function() {
        var plugins = context.settings.plugins;
        return plugins.map(function(item) {
            return (0,html_react_parser/* default */.ZP)(item);
        });
    };
    if (error) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(error_Error, _pathname_objectSpread({}, error)));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.StrictMode, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: context.page.title
                    }),
                    renderAlternates(),
                    renderColorPalette(),
                    renderPlugins(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/...Z4833DT2S5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        children: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', 'G-Z4833DT2S5');\n        "
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_meta_SeoMeta, {
                context: context
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contexts_app/* AppContextProvider */.iz, {
                value: context,
                children: [
                    context.page.layout.map(function(component) {
                        return core_render(component, context);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_manager_CookieManager, {})
                ]
            }),
            renderStyle()
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _pathname_ = (Page);


/***/ })

}]);